import { handleActions } from 'redux-actions';
import {
  closeContactForm,
  createNewContact,
  editingContact,
  loadContacts,
  paginateContacts,
  refreshContacts,
  removeContact,
  searchContacts,
  selectRemoveContact,
  sortContacts,
  updateContact,
  setClearContactList,
  setAddContacts,
  deleteContactTemporary,
  deleteManuallySync,
  setOpenDelete,
  setOpenManuallySync,
} from 'redux/actions/contactActions';

const defaultState = {
  contacts: [],
  currentContacts: [],
  refresh: false,
  searchValue: undefined,
  sortConfig: [],
  openContactModalForm: false,
  editContact: undefined,
  selectedRemoveContact: undefined,
  clearList: false,
  addContacts: [],
  isManuallySync: false,
  isOpenDelete: false,
  isOpenManuallySync: false,
};

export default handleActions(
  {
    [loadContacts](state, action) {
      return { ...state, contacts: action.payload };
    },
    [searchContacts](state, action) {
      return { ...state, searchValue: action.payload };
    },
    [sortContacts](state, action) {
      const { fieldName, isSort } = action.payload;
      return {
        ...state,
        sortConfig: [{ model: 'Contact', field: fieldName, asc: isSort }],
      };
    },
    [setClearContactList](state, action) {
      const clearList = action.payload;
      const searchValue = clearList ? undefined : state.searchValue;
      const sortConfig = clearList
        ? [{ model: 'Contact', field: 'Name', asc: true }]
        : state.sortConfig;
      return { ...state, searchValue, sortConfig, clearList };
    },
    [paginateContacts](state, action) {
      const { page, pageSize } = action.payload;
      const start = (page - 1) * pageSize;
      const end = page * pageSize;
      const currentContacts = [...state.contacts].slice(start, end);
      return { ...state, currentContacts };
    },
    [refreshContacts](state, action) {
      const refresh = action.payload;
      const searchValue = refresh ? '' : state.searchValue;
      const sortConfig = refresh
        ? [{ model: 'Contact', field: 'Name', asc: true }]
        : state.sortConfig;
      return { ...state, refresh, searchValue, sortConfig };
    },
    [createNewContact](state) {
      return { ...state, openContactModalForm: true, editContact: undefined };
    },
    [editingContact](state, action) {
      return { ...state, openContactModalForm: true, editContact: action.payload };
    },
    [updateContact](state, action) {
      const updatedContact = action.payload;
      const contacts = state.contacts.map((contact) =>
        contact.mail === updatedContact.mail ? { ...updatedContact } : contact
      );
      const currentContacts = state.currentContacts.map((contact) =>
        contact.mail === updatedContact.mail ? { ...updatedContact } : contact
      );
      return { ...state, contacts, currentContacts };
    },
    [closeContactForm](state) {
      return { ...state, openContactModalForm: false, editContact: undefined };
    },
    [selectRemoveContact](state, action) {
      return { ...state, selectedRemoveContact: action.payload };
    },
    [removeContact](state, action) {
      const currentContact = action.payload;
      const contacts = state.contacts.filter((contact) => contact.mail !== currentContact.mail);
      const currentContacts = state.currentContacts.filter(
        (contact) => contact.mail !== currentContact.mail
      );
      return { ...state, contacts, currentContacts };
    },
    [setAddContacts](state, action) {
      return { ...state, addContacts: action.payload };
    },
    [deleteContactTemporary](state, action) {
      const { id } = action.payload;
      const temporaryContacts = state.addContacts.filter((item) => item.id !== id);
      return { ...state, addContacts: temporaryContacts };
    },
    [setOpenDelete](state, action) {
      return { ...state, isOpenDelete: action.payload };
    },
    [setOpenManuallySync](state, action) {
      return { ...state, isOpenManuallySync: action.payload };
    },
    [deleteManuallySync](state, action) {
      return { ...state, isManuallySync: action.payload };
    },
  },
  defaultState
);
